/**
 * ilouli-managing 서비스
 * 프로젝트 관리 태스크 API 연동
 * DevTeam API와 연동
 */

const DEVTEAM_API = process.env.REACT_APP_DEVTEAM_API_URL || 'https://devteam.ilouli.com';

/**
 * 인증 헤더 생성
 */
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

/**
 * 프로젝트 목록 조회
 */
export const getProjects = async () => {
  const response = await fetch(`${DEVTEAM_API}/api/managing/projects`, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

/**
 * 태스크 목록 조회
 * @param {Object} params - 필터 파라미터
 * @param {string} params.status - 상태 필터 (진행예정|진행중|진행완료)
 * @param {string} params.project - 프로젝트 필터
 * @param {number} params.limit - 결과 제한
 */
export const getTasks = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append('status', params.status);
  if (params.project) queryParams.append('project', params.project);
  if (params.limit) queryParams.append('limit', params.limit);

  const url = `${DEVTEAM_API}/api/managing/tasks${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

  const response = await fetch(url, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return { tasks: data.data, total: data.total };
};

/**
 * 태스크 상세 조회
 * @param {string} status - 상태
 * @param {string} project - 프로젝트
 * @param {string} taskId - 태스크 ID
 */
export const getTaskDetail = async (status, project, taskId) => {
  const response = await fetch(
    `${DEVTEAM_API}/api/managing/tasks/${status}/${project}/${taskId}`,
    { headers: getAuthHeaders() }
  );
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

/**
 * 상태별 통계 조회
 */
export const getStats = async () => {
  const response = await fetch(`${DEVTEAM_API}/api/managing/stats`, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

/**
 * 공지 초안 목록 조회
 */
export const getAnnouncements = async () => {
  const response = await fetch(`${DEVTEAM_API}/api/managing/announcements`, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

/**
 * 공지 초안 상세 조회
 * @param {string} id - 공지 ID
 */
export const getAnnouncementDetail = async (id) => {
  const response = await fetch(`${DEVTEAM_API}/api/managing/announcements/${id}`, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data.data;
};

/**
 * 공지 초안 게시
 * @param {string} id - 공지 ID
 * @param {Object} payload - 게시 데이터 (title, content)
 */
export const publishAnnouncement = async (id, payload) => {
  const response = await fetch(`${DEVTEAM_API}/api/managing/announcements/${id}/publish`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!data.success) throw new Error(data.error);
  return data;
};

export default {
  getProjects,
  getTasks,
  getTaskDetail,
  getStats,
  getAnnouncements,
  getAnnouncementDetail,
  publishAnnouncement,
};
